import { getDota2MatchRecordCardsData } from '_api/bbs/post'
import Vue from 'vue'
const CptName = 'ComDota2MatchRecordCard'
const CptHeightEnum = {
  'bp': '139px',
  'eco_table': '254px',
  'team_fight': '297px'
}
class Dota2MatchRecordCards {
  #promise
  #resolve
  #article
  constructor (article) {
    this.cards = []
    this.#article = article
    this.results = {}
    this.#promise = new Promise(resolve => this.#resolve = resolve)
  }

  addCards (node) {
    if (
      node.dataset 
      && node.dataset.dota2_matchid 
    ) {
      this.loadCard()
      let card = this.generateCardData(node)
      this.cards.push(card)
      return card
    }
    return node
  }

  loadCard () {
    if (!this.is_load_card) {
      this.dynImport()
      this.is_load_card = true
    }
  }

  dynImport () {
    import('./index.vue').then(cpt => {
      Vue.component(CptName, cpt.default)
      this.cards.forEach(item =>item.cpt = CptName)
    })
  }

  generateCardData (node) {
    return {
      cpt: 'ComCardPlaceholder',
      data: {
        request: (id) => this.handleResult(id),
        time: node.dataset.time,
        type: node.dataset.infotype,
        id: node.dataset.dota2_matchid,
        match_id: node.dataset.matchid,
        hash_tag_id: node.dataset.hash_tag_id,
        placeholder_style: {
          height: CptHeightEnum[node.dataset.infotype],
        }
      }
    }
  }

  request () {}

  async handleResult (id) {
    if (this.#article.options.preload) return
    if (!this.results[id]) {
      let { data: {result, status}} = await getDota2MatchRecordCardsData({
        match_id: id
      })
      // test
      // if (id == '7341448039') {
      //   result = require('../../mock/dota2_news.json').result
      // }
      if (status != 'ok') {
        return
      }
      let info = {
        ban_pick: result.data.ban_pick,
        eco_table: [],
        team_fight: [],
        stat: result.stat
      }
      result.data.time_line.forEach((item) => {
        if (item.type === 'compare_table') {
          item = JSON.parse(JSON.stringify(item))
          item.tables = item.tables.map((table) => {
            table.total_compare_icon = result.data.icon_list[table.total_compare_icon_idx]
            var radiant_eco = 0
            var dire_eco = 0
            var max = 0
            table.table_list = table.table_list.map((tb) => {
              tb.data_list = tb.data_list.map((d) => {
                var h = result.data.hero_infos[d.hero_idx]
                d.hero_image = result.data.icon_list[h.icon_idx]
                var team_index = this.searchItem(result.data.team_infos, 'id', h.team_id)
                if (team_index >= 0) {
                  var team_name = result.data.team_infos[team_index].desc
                }
                max = Math.max(max, d.value)
                if (team_name === '天辉') {
                  radiant_eco += d.value
                } else {
                  dire_eco += d.value
                  d.is_dire = true
                }
                return d
              })
              return tb
            })
            if (table.table_list[0]) {
              table.table_list = table.table_list[0]
            } else {
              table.table_list = {
                compare: false,
                title: "",
                data_list: []
              }
            }
            table.max = max
            table.radiant_eco = radiant_eco
            table.dire_eco = dire_eco
            return table
          })
          if (item.tables[0]) {
            info.eco_table.push(Object.assign({}, item.tables[0], {
              time: item.time
            }))
          }
        } else if (item.type === 'team_fight') {
          item = JSON.parse(JSON.stringify(item))
          var act_max = 0
          var max = 0
          item.teams = item.teams.map((team) => {
            var team_index = this.searchItem(result.data.team_infos, 'id', team.team_id)
            if (team_index >= 0) {
              team.team_name = result.data.team_infos[team_index].desc
            }
            team.heroes = team.heroes.map((h) => {
              h.hero_image = result.data.icon_list[h.hero_idx]
              h.act_list = h.act_list.map((act) => {
                act.img = result.data.icon_list[act.icon_idx]
                return act
              })
              act_max = Math.max(act_max, h.act_list.length)
              max = Math.max(max, h.value)
              return h
            })
            return team
          })
          item.act_max = act_max
          item.max = max
          info.team_fight.push(item)
        }
      })
      this.results[id] = info
    }
    return this.results[id]
  }

  searchItem (list, key, value) {
    let index = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i][key] == value) {
        index = i
        break;
      }
    }
    return index
  }
}

export default Dota2MatchRecordCards